import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '../MetricLoader';
import DeltaMetric from '../DeltaMetric';
import { tags_partner } from '../../../utils/query-helpers';

export default function TotalYear(props) {
  const { network, schoolStart, schoolEnd, titleOnly, name = 'Total' } = props;

  const allOrganizations = useConnect('organization.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfPartners',
            relation: 'users',
            $where: {
              ...tags_partner(),
              // 'networks.id': network?.id
              networkId: network?.id,
              createdAt: {
                $lte: schoolEnd
              }
            }
          }
        ],
        $where: {
          // createdAt: {
          //   $lte: schoolEnd
          // }
        },
        $having: {
          numberOfPartners: {
            $gt: 0
          }
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  // const newOrganizations = useConnect('organization.find', {
  //   where: {
  //     eager: {
  //       $aggregations: [
  //         {
  //           type: 'count',
  //           alias: 'numberOfPartners',
  //           relation: 'users',
  //           $where: {
  //             ...tags_partner(),
  //             // 'networks.id': network?.id
  //             networkId: network?.id,
  //             createdAt: {
  //               $lte: schoolEnd,
  //               $gte: schoolStart
  //             }
  //           }
  //         }
  //       ],
  //       $where: {
  //         numberOfPartners: {
  //           $gt: 0
  //         },
  //         // createdAt: {
  //         //   $lte: schoolEnd,
  //         //   $gte: schoolStart
  //         // }
  //       }
  //     }
  //   },
  //   pagination: {
  //     pageSize: 1
  //   }
  // });

  const previousOrganizations = useConnect('organization.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfPartners',
            relation: 'users',
            $where: {
              ...tags_partner(),
              // 'networks.id': network?.id
              networkId: network?.id,
              createdAt: {
                $lte: schoolStart
              }
            }
          }
        ],
        $where: {
          // createdAt: {
          //   $lte: schoolEnd,
          //   $gte: schoolStart
          // }
        },
        $having: {
          numberOfPartners: {
            $gt: 0
          }
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  if (
    allOrganizations.state === PayloadStates.FETCHING ||
    previousOrganizations.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name={name}
      />
    );
  }

  return (
    <DeltaMetric
      name={name}
      value={allOrganizations.meta.totalCount}
      delta={allOrganizations.meta.totalCount - previousOrganizations.meta.totalCount}
      titleOnly={titleOnly}
    />
  );
}
